import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Badge } from 'react-bootstrap';
import { UilSetting } from '@iconscout/react-unicons';
import { isLiveTimeRange } from '../charts/utils/chartUtils';
import { INFLUX_API } from '../../config/api';

const MachineModeStatus = ({ bucket, machineName, startTime, endTime }) => {
  const [loading, setLoading] = useState(true);
  const [machineMode, setMachineMode] = useState(null);

  const fetchData = async () => {
    try {
      const response = await axios.get(
        `${INFLUX_API}/api/influx/${machineName}/mode?start=${startTime}&end=${endTime}&bucket=${bucket}`
      );

      if (response.data.length > 0) {
        setMachineMode(response.data[0]._value);
      }
    } catch (error) {
      console.error('Error fetching machine mode:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
    const intervalId = isLiveTimeRange(endTime) ? setInterval(fetchData, 6000) : null; // Refresh every 6 seconds
    return () => clearInterval(intervalId);
  }, [startTime, endTime]);

  // Determine badge color based on mode
  const getBadgeColor = () => {
    switch (machineMode) {
      case 'PRODUCTION':
        return 'success'; // Green
      case 'CLEAN UP':
        return 'danger'; // Red (WASTE)
      case 'UNWINDING':
        return 'primary'; // Blue
      default:
        return 'secondary'; // Gray for unknown state
    }
  };

  return (
    <Badge
      variant="phoenix"
      bg={getBadgeColor()}
      iconPosition="end"
      icon={<UilSetting size={12} className="ms-1" />}
    >
      {loading ? 'Loading...' : `MODE: ${machineMode || 'UNKNOWN'}`}
    </Badge>
  );
};

export default MachineModeStatus;
